import React from "react";
import { CreateTimeoffRuleRequestType } from "../../../types/request/timeoff";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { TimeoffPolicyType } from "../../../types";

export type BasicInfoStepProps = {
    formData: CreateTimeoffRuleRequestType;
    setFormData: React.Dispatch<React.SetStateAction<CreateTimeoffRuleRequestType>>;
    policyTypes: TimeoffPolicyType[]
};

const BasicInfoStep = ({ formData, setFormData, policyTypes }: BasicInfoStepProps) => {
    const timeoffCategories = useSelector((state: RootState) => state.common.allTimeoffCategories);

    return (
        <div className="bg-white p-6 shadow rounded">
            <h2 className="text-xl font-semibold mb-2">Basic Info</h2>

            {/* Policy Name */}
            <div className="mb-4">
                <label className="block text-gray-700">Policy Name</label>
                <input
                    type="text"
                    className="w-full px-3 py-2 border rounded"
                    placeholder="e.g. Salary Employees"
                    value={formData.policy_name || ""}
                    onChange={(e) => setFormData({ ...formData, policy_name: e.target.value })}
                />
            </div>

            {/* Policy code */}
            <div className="mb-4">
                <label className="block text-gray-700">Policy Code</label>
                <input
                    type="text"
                    className="w-full px-3 py-2 border rounded"
                    placeholder="e.g. emp_salary"
                    value={formData.policy_code || ""}
                    onChange={(e) => setFormData({ ...formData, policy_code: e.target.value })}
                />
            </div>

            {/* Policy type Selection */}
            <div className="mt-4">
                <label className="block text-gray-700">Policy Type</label>
                <select
                    className="w-full px-3 py-2 border rounded"
                    value={formData.policy_type}
                    onChange={(e) => setFormData({ ...formData, policy_type: e.target.value })}
                >
                    <option value="">Select</option>
                    {policyTypes.map((type, index) => {
                        return (
                            <option value={type.code} key={index}>
                                {type.name}
                            </option>
                        );
                    })}
                </select>
            </div>

            {/* Category Selection */}
            <div className="mt-4">
                <label className="block text-gray-700">Category</label>
                <select
                    className="w-full px-3 py-2 border rounded"
                    value={formData.category_code}
                    onChange={(e) => setFormData({ ...formData, category_code: e.target.value })}
                >
                    <option value="">Select</option>
                    {timeoffCategories.map((category, index) => {
                        return (
                            <option value={category.category_code} key={index}>
                                {category.category_name}
                            </option>
                        );
                    })}
                </select>
            </div>
        </div>
    );
};

export default BasicInfoStep;
